import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'
let sub = window.location.pathname
let base = window.location.protocol + '//' + window.location.host + '' + sub
Vue.use(VueLocalStorage)
// Condition check to use the base url dynamically
if (window.location.href.indexOf('localhost') > 0) {

  // Local machine
  alert('THIS IS THE TEST ENVIRONMENT')

  window.baseUrl = 'http://localhost:55828/'
} 
else {
  // remote machine api url
  window.baseUrl = base + '/api/'
  //alert(base+'/api/')
}



$.ajaxSetup({
  beforeSend: function (xhr, options) {

    var auth = JSON.parse(Vue.localStorage.get('authentication'))
    if (auth) {

      if (auth.access_token) {
        xhr.setRequestHeader('Accept', 'application/vvv.website+json;version=1')
        xhr.setRequestHeader('Authorization', 'Bearer ' + auth.access_token)

      }
    }
    if (options.url.indexOf('darksky') < 1) {

      options.url = window.baseUrl + options.url
    }
  }



})



// WEBPACK FOOTER //
// ./src/Http_Config/ajax.conf.js